import { lighten } from 'polished';
import styled from 'styled-components';

export const Container = styled('div')`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const ContainerMessage = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 1.5rem;
  min-height: 50vh;
  height: 75vh;
  max-height: 75vh;
  border-radius: 0 0 16px 16px;
  border: 1px solid #e0e0e0;
`;

export const IconContent = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 4rem;
  height: 4rem;
  border-radius: 100%;
  background-color: ${lighten(0.45, '#ED6C02')};
  color: #ed6c02;
  .MuiSvgIcon-root {
    font-size: 2.35rem;
  }
`;

export const InfoContent = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 75%;
  color: #e62b2b;
`;

export const HeaderEmpty = styled('div')`
  width: auto;
  display: flex;
  justify-content: flex-end;

  align-items: center;
  padding: 16px;
  border-radius: 16px 16px 0px 0px;
  border: 1px solid #e0e0e0;
`;
